/** Points-to-screen fragment shader. */

precision highp float;

varying float wide;
varying vec3 sphere;
varying vec4 color;

#pragma glslify: gt = require(glsl-conditionals/when_gt);

void main() {
  float r = sphere.p;
  float r2 = r*r;
  vec2 cf = gl_FragCoord.xy-sphere.xy;
  float cfl2 = dot(cf, cf);
  float isWide = gt(wide, 1.0);

  #ifdef useDiscard
    if(isWide*cfl2 > r2) { discard; }
  #endif

  float fade = max(r2-(isWide*cfl2), 0.0);

  #ifdef lengthLinear
    fade = sqrt(fade)/r;
  #else
    fade = fade/r2;
  #endif

  gl_FragColor = color*fade;
  gl_FragColor.rgb *= gl_FragColor.a;
}
